module.exports = __webpack_public_path__ + "static/media/typeA2.e8897e6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/hero/typeA2.png
// module id = 1214
// module chunks = 0